import { Button, Field, Select } from '@yingbaba/ui';

export function ReceiptFilters({
  states,
  status,
  onStatus,
  orderLabel,
  statusLabel,
  search,
  onSearch,
  onSubmit,
}: {
  states: Record<string, string>;
  status: string;
  onStatus: (value: string) => void;
  orderLabel: string;
  statusLabel: string;
  search: string;
  onSearch: (value: string) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <div className="admin-data-toolbar">
      <Field label={statusLabel}>
        <Select aria-label={statusLabel} value={status} onChange={onStatus}>
          <option value="">全部到账状态</option>
          {Object.entries(states).map(([value, text]) => (
            <option key={value} value={value}>
              {text}
            </option>
          ))}
        </Select>
      </Field>
      <form
        className="admin-record-search"
        role="search"
        aria-label="收款记录检索"
        onSubmit={onSubmit}
      >
        <Field label={orderLabel}>
          <input
            className="input"
            aria-label={orderLabel}
            value={search}
            onChange={(event) => onSearch(event.target.value)}
            maxLength={26}
            placeholder="输入完整订单编号"
          />
        </Field>
        <Button type="submit" variant="secondary">
          查询到账
        </Button>
      </form>
    </div>
  );
}
